// extracted by mini-css-extract-plugin
module.exports = {"error":"FormError-module--error--27oOk"};